import { computed } from 'vue'
import { settingStore } from '../store/settingStore'
import { store } from '../../store'

export const CHECK_INPUT_CHAR = (value, maxLimitStr) => {
    let cnReg = /([\u4e00-\u9fa5]|[\u3000-\u303F]|[\uFF00-\uFF60]|[\u3100-\u312F])/;

    let pass = true
    let substringStr = ''
    let length = 0
    let strArr = value.split('')

    strArr.map((str) => {
        if (pass) {
            if (cnReg.test(str)) {
                length += 2;
            } else {
                length++;
            }

            if (length > maxLimitStr) {
                pass = false;
            } else {
                substringStr += str;
            }
        }
    });

    return { pass, substringStr };
}
